import { useEffect, useState } from 'react';
import client from '../api/client';
import { useAuth } from '../context/AuthContext';

const actionColor = {
  CREATE_STAFF: '#1a5cff', EDIT_STAFF: '#d97706', DELETE_STAFF: '#e05c5c',
  CHANGE_PLAN: '#059669', SUSPEND_TENANT: '#dc2626', APPROVE_REP: '#7c3aed',
  REJECT_REP: '#b45309', MARK_COMMISSIONS_PAID: '#059669',
  RESET_STAFF_PIN: '#0891b2', REQUEST_EDIT_STAFF_OTP: '#4a6580'
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [actionFilter, setActionFilter] = useState('');
  const { role } = useAuth();

  const allowed = ['SUPER_ADMIN', 'ADMIN', 'REGIONAL_MANAGER'].includes(role);

  const load = () => {
    setLoading(true);
    const p = new URLSearchParams({ page, size: 50 });
    if (actionFilter) p.append('action', actionFilter);
    client.get('/admin/audit-log?' + p)
      .then(r => { setLogs(r.data.logs || []); setTotal(r.data.total || 0); })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { if (allowed) load(); }, [page, actionFilter]);

  if (!allowed) return (
    <div>
      <h1 style={{ color:'#000', fontSize:22, fontWeight:700, margin:'0 0 24px', fontFamily:'Georgia,serif' }}>Audit Log</h1>
      <div style={{ background:'#fff', borderRadius:12, padding:40, border:'1px solid #eee', textAlign:'center' }}>
        <div style={{ fontSize:40, marginBottom:16 }}>🔒</div>
        <div style={{ color:'#e05c5c', fontSize:16, fontWeight:600 }}>Access Restricted</div>
        <div style={{ color:'#555', fontSize:14, marginTop:8 }}>Only Super Admin, Admin, and Regional Manager can view audit logs.</div>
      </div>
    </div>
  );

  const actions = ['CREATE_STAFF','EDIT_STAFF','DELETE_STAFF','CHANGE_PLAN','SUSPEND_TENANT','APPROVE_REP','REJECT_REP','MARK_COMMISSIONS_PAID'];

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h1 style={{ color:'#000', fontSize:22, fontWeight:700, margin:'0 0 4px', fontFamily:'Georgia,serif' }}>Audit Log</h1>
          <p style={{ color:'#555', fontSize:13, margin:0 }}>{total} total entries</p>
        </div>
        <select
          value={actionFilter}
          onChange={e => { setActionFilter(e.target.value); setPage(0); }}
          style={{ padding:'9px 14px', background:'#f9f9f9', border:'1px solid #ddd', borderRadius:8, color:'#000', fontSize:13, outline:'none' }}>
          <option value="">All Actions</option>
          {actions.map(a => <option key={a} value={a}>{a.replace(/_/g,' ')}</option>)}
        </select>
      </div>

      <div style={{ background:'#fff', borderRadius:12, border:'1px solid #eee', overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr style={{ borderBottom:'1px solid #eee' }}>
              {['When','Who','Role','Action','Target','Details'].map(h => (
                <th key={h} style={{ color:'#555', fontSize:11, fontWeight:500, textAlign:'left', padding:'14px 16px', textTransform:'uppercase' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} style={{ color:'#555', padding:24, textAlign:'center' }}>Loading...</td></tr>
            ) : logs.length === 0 ? (
              <tr><td colSpan={6} style={{ color:'#555', padding:24, textAlign:'center' }}>No audit logs yet</td></tr>
            ) : logs.map((log, i) => (
              <tr key={log.id} style={{ borderBottom:'1px solid #f5f5f5' }}>
                <td style={{ padding:'11px 16px', color:'#555', fontSize:12, whiteSpace:'nowrap' }}>
                  {log.created_at ? new Date(log.created_at).toLocaleString() : '—'}
                </td>
                <td style={{ padding:'11px 16px', color:'#000', fontSize:13, fontWeight:500 }}>
                  {log.performed_by_name || '—'}
                </td>
                <td style={{ padding:'11px 16px' }}>
                  <span style={{ background:'#f9f9f9', color:'#444', padding:'2px 7px', borderRadius:4, fontSize:11, fontWeight:600 }}>
                    {log.performed_by_role || '—'}
                  </span>
                </td>
                <td style={{ padding:'11px 16px' }}>
                  <span style={{ background:(actionColor[log.action]||'#4a6580')+'22', color:actionColor[log.action]||'#4a6580', padding:'3px 8px', borderRadius:4, fontSize:12, fontWeight:700 }}>
                    {(log.action||'').replace(/_/g,' ')}
                  </span>
                </td>
                <td style={{ padding:'11px 16px' }}>
                  <div style={{ color:'#000', fontSize:13 }}>{log.entity_name||'—'}</div>
                  <div style={{ color:'#555', fontSize:11 }}>{log.entity_type||''}</div>
                </td>
                <td style={{ padding:'11px 16px', color:'#333', fontSize:13, maxWidth:250 }}>
                  <div style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{log.details||'—'}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {total > 50 && (
          <div style={{ padding:'16px 20px', borderTop:'1px solid #eee', display:'flex', gap:8, justifyContent:'center' }}>
            <button disabled={page===0} onClick={()=>setPage(p=>p-1)}
              style={{ padding:'7px 16px', background:page===0?'#f9f9f9':'#1a5cff', color:'#000', border:'none', borderRadius:6, cursor:page===0?'not-allowed':'pointer', fontSize:13 }}>← Prev</button>
            <span style={{ color:'#555', fontSize:13, padding:'7px 12px' }}>Page {page+1}</span>
            <button disabled={(page+1)*50>=total} onClick={()=>setPage(p=>p+1)}
              style={{ padding:'7px 16px', background:(page+1)*50>=total?'#f9f9f9':'#1a5cff', color:'#000', border:'none', borderRadius:6, cursor:(page+1)*50>=total?'not-allowed':'pointer', fontSize:13 }}>Next →</button>
          </div>
        )}
      </div>
    </div>
  );
}
